var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DecorationSet, Decoration } from "prosemirror-view";
import { Plugin } from "prosemirror-state";
import { isTableSelected, isRowSelected, getCellsInColumn, } from "prosemirror-utils";
import Node from "./Node";
var TableCell = /** @class */ (function (_super) {
    __extends(TableCell, _super);
    function TableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TableCell.prototype, "name", {
        get: function () {
            return "td";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableCell.prototype, "schema", {
        get: function () {
            return {
                content: "paragraph+",
                tableRole: "cell",
                isolating: true,
                parseDOM: [{ tag: "td" }],
                toDOM: function (node) {
                    return [
                        "td",
                        node.attrs.alignment
                            ? { style: "text-align: " + node.attrs.alignment }
                            : {},
                        0,
                    ];
                },
                attrs: {
                    colspan: { default: 1 },
                    rowspan: { default: 1 },
                    alignment: { default: null },
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    TableCell.prototype.toMarkdown = function (state, node) {
        state.renderContent(node);
    };
    TableCell.prototype.parseMarkdown = function () {
        return {
            block: "td",
            getAttrs: function (tok) { return ({ alignment: tok.info }); },
        };
    };
    Object.defineProperty(TableCell.prototype, "plugins", {
        get: function () {
            var _this = this;
            return [
                new Plugin({
                    props: {
                        decorations: function (state) {
                            var doc = state.doc, selection = state.selection;
                            var decorations = [];
                            var cells = getCellsInColumn(0)(selection);
                            if (cells) {
                                cells.forEach(function (_a, index) {
                                    var pos = _a.pos;
                                    if (index === 0) {
                                        decorations.push(Decoration.widget(pos + 1, function () {
                                            var className = "grip-table";
                                            var selected = isTableSelected(selection);
                                            if (selected) {
                                                className += " selected";
                                            }
                                            var grip = document.createElement("a");
                                            grip.className = className;
                                            grip.addEventListener("mousedown", function (event) {
                                                event.preventDefault();
                                                _this.options.onSelectTable(state);
                                            });
                                            return grip;
                                        }));
                                    }
                                    decorations.push(Decoration.widget(pos + 1, function () {
                                        var rowSelected = isRowSelected(index)(selection);
                                        var className = "grip-row";
                                        if (rowSelected) {
                                            className += " selected";
                                        }
                                        if (index === 0) {
                                            className += " first";
                                        }
                                        else if (index === cells.length - 1) {
                                            className += " last";
                                        }
                                        var grip = document.createElement("a");
                                        grip.className = className;
                                        grip.addEventListener("mousedown", function (event) {
                                            event.preventDefault();
                                            _this.options.onSelectRow(index, state);
                                        });
                                        return grip;
                                    }));
                                });
                            }
                            return DecorationSet.create(doc, decorations);
                        },
                    },
                }),
            ];
        },
        enumerable: true,
        configurable: true
    });
    return TableCell;
}(Node));
export default TableCell;
